import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function getValueByPath(obj, pathArray) {
  try {
    return pathArray.reduce((acc, key) => acc && acc[key], obj);
  } catch (e) {
    return undefined;
  }
}

function replacePlaceholders(html, data) {
  return html.replace(/\["(.+?(\r?\n|.)*?)"\]/g, (_, path) => {
    const pathArray = path.split(',').map((key) => key.replace(/\s+/g, ''));
    console.log('########### path array is ', pathArray);
    const value = getValueByPath(data, pathArray);
    return value ? value : `["${path}"]`;
  });
}

const downloadCertificate = () => {
  const certificateElement = document.querySelector('.certificate_cont');
  certificateElement.classList.add('printable');
  window.print();
  certificateElement.classList.remove('printable');
};

export function CertificateTemplateRenderer({
  url,
  cssUrl,
  data,
  setErrorOnLoadTemplate,
}) {
  const [htmlContent, setHtmlContent] = useState('');
  const [styles, setStyles] = useState('');
  const { t } = useTranslation('library');
  useEffect(() => {
    // Fetch the HTML content
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        setErrorOnLoadTemplate(false);
        const replacedHtml = replacePlaceholders(html, data);
        setHtmlContent(replacedHtml);
      })
      .catch((error) => {
        console.error('Error loading HTML:', error);
        setErrorOnLoadTemplate(true);
      });

    // Fetch the CSS content
    if (cssUrl) {
      fetch(cssUrl)
        .then((response) => response.text())
        .then((css) => setStyles(css))
        .catch((error) => console.error('Error loading CSS:', error));
    }
  }, [url, cssUrl, data, setErrorOnLoadTemplate]);

  return (
    <div className="certificate_cont">
      {/* Inject scoped CSS specifically for this div */}
      <style dangerouslySetInnerHTML={{ __html: styles }} />

      {/* Render HTML content */}
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      {localStorage.getItem('axd_token') && (
        <div
          className="div-block-475 add_skill certificate_download_button"
          onClick={downloadCertificate}
          style={{ minWidth: '200px', marginTop: '20px' }}
        >
          <img
            src="/images/download.png"
            loading="lazy"
            alt=""
            className="image-152 add_sk"
          />
          <div className="text-block-284 add_skill_text">
            {t('Download Certificate')}
          </div>
        </div>
      )}
    </div>
  );
}
